import React, { useState, useEffect, useRef } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import 'react-pro-sidebar/dist/css/styles.css';
import { Box, Icon, IconButton, Typography, useTheme, useThemeProps } from "@mui/material";
import DashboardIcon from '@mui/icons-material/Dashboard';
//import Icon from '@mui/material/Icon';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Link, useHistory } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import MapOutlinedIcon from "@mui/icons-material/StorageSharp";
import EqualizerOutlinedIcon from '@mui/icons-material/EqualizerOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import ListItemIcon from '@mui/material/ListItemIcon';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import axios from 'axios';
import LoginForm from '../../Login';
import Dashboard from "./Dashboard";


const Item = ({ title, to, icon, selected, setSelected, onSidebarCollapse }) => {
  /* const theme = useTheme();
  const colors = tokens(theme.palette.mode);
 */
  const handleclick = () => {
    setSelected(title);
    if (onSidebarCollapse) {
      onSidebarCollapse();
    }
  };

  return (
    <MenuItem
      active={selected === title}
      /*  style={{
         color: colors.grey[100],
       }} */
      onClick={handleclick}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};


const Sidebar = ({ name, selectedCompany, selectedDept, selectedYear, handleLogout }) => {
  /*  const theme = useTheme();
   const colors = tokens(theme.palette.mode); */
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selected, setSelected] = useState("Dashboard");
  const [isMasterCollapsed, setIsMasterCollapsed] = useState(false);
  const [isTransactionCollapsed, setIsTransactionCollapsed] = useState(false);
  const [isReportsCollapsed, setIsReportsCollapsed] = useState(false);
  const [isGraphCollapsed, setIsGraphCollapsed] = useState(false);
  const [compMasterEntries, setCompMasterEntries] = useState([]);

  const [selectedMaster, setSelectedMaster] = useState("AcGroupMaster");
  const [users, setUsers] = useState([]);
  const [canCreateUser, setCanCreateUser] = useState(false);

  const sidebarRef = useRef(null);

  const handleMouseEnter = () => {
    if (isCollapsed) {
      setIsCollapsed(false);
    }
  }

  const handleMouseLeave = () => {
    if (!isCollapsed) {
      setIsCollapsed(true);
    }
  }

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    fetchCompMaster();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/getusers');
      //console.log(response); // Check the response structure
      setUsers(response.data); // Assuming response.data.users is an array
      const currentUser = response.data.find(u => u.UserName === name && u.Administrator === 1);
      setCanCreateUser(!!currentUser);
      //console.log(currentUser);
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const findCompanyName = (code) => {
    const companyName = compMasterEntries.find((group) => group.CompCode === code)?.CompName || '';
    const companyNameParts = companyName.split(' ');
    return companyNameParts.slice(0, 2).join(' ').trim();
};


const fetchCompMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/company');
      setCompMasterEntries(response.data);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        // Clicked outside the sidebar, close it
        setIsCollapsed(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const canAccess = selectedCompany && selectedDept && selectedYear;

  // Define a separate class for sidebar background color
  const sidebarBackgroundColorClass = isCollapsed ? 'static-sidebar-collapsed' : 'static-sidebar-expanded';

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        zIndex: 9999,
        "&:hover .pro-sidebar-collapsed": {
          "& .pro-sidebar-inner": {
            width: "auto",
          },
          "& .pro-inner-item": {
            opacity: 1,
          }
        },
        "& .pro-sidebar-inner": {
          background: "#151533  !important",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
        "& .MuiSvgIcon-root": {
          fill: "#fff !important", // Set the static white color for all SVG icons
        },
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              // color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={"white"}>
                  {findCompanyName(selectedCompany)}
                </Typography>
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="100px"
                  height="100px"
                  src={`../../assets/user.png`}
                  style={{ cursor: "pointer", borderRadius: "50%" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  /* color={colors.grey[100]} */
                  color={"white"}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  G A P
                </Typography>
                <Typography variant="h5" color={"white"}/* color={colors.greenAccent[500]} */>
                  General Accounting Package Ver 1.1
                </Typography>
                <Typography variant="h5" color={"white"}/* color={colors.greenAccent[200]} */>
                  User:- {name}
                </Typography>
              </Box>
            </Box>
          )}
          <Link to="/SelectCompany" style={{ textDecoration: 'none' }}>
            <MenuItem
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: selectedCompany && selectedDept && selectedYear ? "#4caf50" : "#2196f3",
                marginBottom: "10px",
                cursor: "pointer",
                borderRadius: "10px",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              {!isCollapsed ? (
                <Typography variant="h6" color={"white"}/* color={colors.grey[100]} */>
                  SELECT COMPANY
                </Typography>
              ) : (
                <Typography variant="h6" style={{ marginLeft: "13px" }} color={"white"}/* color={colors.grey[100]} */>
                  <Icon>
                    <CheckBoxIcon />
                  </Icon>
                </Typography>
              )}
            </MenuItem>
          </Link>
          <br />
          {canAccess && (
            <React.Fragment>
              <MenuItem onClick={() => setIsMasterCollapsed(!isMasterCollapsed)}>
                <ListItemIcon sx={{ float: 'right', marginTop: '10px', marginRight: '-40px' }}>
                  {isMasterCollapsed ? <ChevronRightIcon /> : <ExpandMoreIcon />}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h6" style={{ fontSize: '18px', marginLeft: '15px', color: isMasterCollapsed && 'white' }}>
                      {!isCollapsed ? "Masters" : ""}
                    </Typography>
                  }
                />
              </MenuItem>
              <Collapse in={isMasterCollapsed}>
                <List>
                  <Box paddingLeft={isCollapsed ? undefined : "4%"}>
                    <Item
                      title="Party Master"
                      to="/SubLedgerMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />

                    <Item
                      title="Item Master"
                      to="/ItemMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                      <Item
                        title="Quality Check Master"
                        to="/QualityCheckMaster"
                        icon={<MapOutlinedIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    <Item
                      title="Internal Dept Master"
                      to="/InternalDeptMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="Production Formula Master"
                      to="/ProdFormulaMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Ledger Master"
                      to="/LedgerMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Group Master"
                      to="/AcGroupMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    

                    <Item
                      title="Designation Master"
                      to="/DesignationMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="Employee Master"
                      to="/EmployeeMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                      //onSidebarCollapse={() => setIsCollapsed(true)} 
                    />
                    <Item
                      title="Grade Master"
                      to="/GradeMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    /*  onSidebarCollapse={() => setIsCollapsed(true)} */
                    />
                    {/* <Item
                      title="Process Master"
                      to="/ProcessMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    /> */}
                    {/* <Item
                      title="Rejection Master"
                      to="/RejectionMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    /> */}
                    <Item
                      title="GSTRates Master"
                      to="/GSTRatesMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Item Category Master"
                      to="/ItemCategoryMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Item Group Master"
                      to="/ItemGroupMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Item SubGroup Master"
                      to="/ItemSubGroupMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />



                    <Item
                      title="Location Master"
                      to="/LocationMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />

                    <Item
                      title="Narration Master"
                      to="/NarrationMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />

                    {/* <Item
                      title="Nature Master"
                      to="/NatureMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    /> */}

                    <Item
                      title="Packing Master"
                      to="/PackingMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />
                    <Item
                      title="Setting Master"
                      to="/SettingMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    /*  onSidebarCollapse={() => setIsCollapsed(true)} */
                    />

                    <Item
                      title="State Master"
                      to="/StateMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />

                    <Item
                      title="Status Master"
                      to="/StatusMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    /*  onSidebarCollapse={() => setIsCollapsed(true)} */
                    />

                    <Item
                      title="Sub LedgerGroup Master"
                      to="/SubLedgerGroupMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />
                    <Item
                      title="Unit Master"
                      to="/UnitMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />
                    <Item
                      title="Vehicle Master"
                      to="/VehicleMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    /*  onSidebarCollapse={() => setIsCollapsed(true)} */
                    />
                    {/* <Item
                      title="Digit Master"
                      to="/DigitMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    //  onSidebarCollapse={() => setIsCollapsed(true)} 
                    /> */}
          
                    <Item
                      title="Dept Master"
                      to="/DeptMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Company Master"
                      to="/CompanyMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    /*  onSidebarCollapse={() => setIsCollapsed(true)} */
                    />
                    <Item
                      title="Year Master"
                      to="/YearMaster"
                      icon={<MapOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    /* onSidebarCollapse={() => setIsCollapsed(true)} */
                    />


                    {/* <Item
                  title="Tran Ledger Master"
                  to="/TranLedgerMaster"
                  icon={<MapOutlinedIcon />}
                  selected={selected}
                  
                  setSelected={setSelected}
                />
                
                

                <Item
                  title="TranItMaster"
                  to="/TranItMaster"
                  icon={<MapOutlinedIcon />}
                  selected={selected}
                  
                  setSelected={setSelected}
                />


                <Item
                  title="TranSubLedgerMaster"
                  to="/TranSubLedgerMaster"
                  icon={<MapOutlinedIcon />}
                  selected={selected}
                  
                  setSelected={setSelected}
                />
 */}
                    {canCreateUser && (
                      <Item
                        title="Create user"
                        to="/createuser"
                        icon={<MapOutlinedIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    )}
                  </Box>
                </List>
              </Collapse>

              <MenuItem onClick={() => setIsTransactionCollapsed(!isTransactionCollapsed)}>
                <ListItemIcon sx={{ float: 'right', marginTop: '10px', marginRight: '-40px' }}>
                  {isTransactionCollapsed ? <ChevronRightIcon /> : <ExpandMoreIcon />}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h6" noWrap sx={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '18px', marginLeft: '15px', color: isTransactionCollapsed && 'white' }}>
                      {!isCollapsed ? "Transactions" : ""}
                    </Typography>
                  }
                />
                {/* <ListItemText
              primary={
                <Typography variant="h6" style={{ fontSize: '18px', marginLeft: '15px', color: isTransactionCollapsed && 'white' }}>
                  {!isCollapsed ? "Transactions" : ""}
                </Typography>
              }
            /> */}
              </MenuItem>
              <Collapse in={isTransactionCollapsed}>
                <List>
                  <Box paddingLeft={isCollapsed ? undefined : "4%"}>
                    <Item
                      title="PurchaseOrderEntryOfCustomer"
                      to="/NewSellEntry?flag=POC&title=Purchase%20Order%20Entry%20Of%20Customer"
                      icon={<CurrencyRupeeIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />
                    <Item
                      title="PurchaseOrderEntryOfSupplier"
                      to="/NewSellEntry?flag=POS&title=Purchase%20Order%20Entry%20Of%20Supplier"
                      icon={<CurrencyRupeeIcon />}
                      selected={selected}

                      setSelected={setSelected}
                    />
                    <Item
                      title="GRNEntry"
                      to="/NewSellEntry?flag=GRN&title=GRN%20Entry"
                      icon={<CurrencyRupeeIcon />}
                      style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="QualityCheck"
                      to="/QualityCheckEntry"
                      icon={<CurrencyRupeeIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="ConsumptionEntry"
                      to="/NewSellEntry?flag=RECD&title=Consumption%20Entry"
                      icon={<CurrencyRupeeIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="ProductionPlanEntry"
                      to="/Production?flag=PRODPL&title=Production%20Plan%20Entry"
                      icon={<CurrencyRupeeIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="ProductionEntry"
                      to="/Production?flag=PROD&title=Production%20Entry"
                      icon={<CurrencyRupeeIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="PackingEntry"
                      to="/Packing?flag=PACK&title=Packing%20Entry"
                      icon={<CurrencyRupeeIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="DespatchEntry"
                      to="/NewSellEntry?flag=SENT&title=Despatch%20Entry"
                      icon={<CurrencyRupeeIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </Box>
                </List>
              </Collapse>

              <MenuItem onClick={() => setIsReportsCollapsed(!isReportsCollapsed)}>
                <ListItemIcon sx={{ float: 'right', marginTop: '10px', marginRight: '-40px' }}>
                  {isReportsCollapsed ? <ChevronRightIcon /> : <ExpandMoreIcon />}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h6" style={{ fontSize: '18px', marginLeft: '15px', color: isReportsCollapsed && 'white' }}>
                      {!isCollapsed ? "Reports" : ""}
                    </Typography>
                  }
                />
              </MenuItem>
              <Collapse in={isReportsCollapsed}>
                <List>
                  <Box paddingLeft={isCollapsed ? undefined : "4%"}>
                    <Item
                      title="Purchase Order Customer"
                      to="/ReportData/PurchaseOrderRegister?flag=POC"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="Purchase Order Supplier"
                      to="/ReportData/PurchaseOrderRegister?flag=POS"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="GRNRegister"
                      to="/ReportData/GRNRegister?flag=GRN"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="QualityCheckRegister"
                      to="/ReportData/QualityCheckRegister?flag=QUAL"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="ProductionRegister"
                      to="/ReportData/ProductionRegister?flag=PROD"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="ConsumptionRegister"
                      to="/ReportData/ConsumptionRegister?flag=CONS"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Packing Register"
                      to="/ReportData/PackingRegister?flag=PACK"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Despatch Register"
                      to="/ReportData/DespatchRegister?flag=DESP"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Stock Ledger"
                      to="/ReportData/stockLedgerr"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    <Item
                      title="Stock Statement"
                      to="/ReportData/stockStatement"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                    <Item
                      title="Batchwise Stock"
                      to="/ReportData/BatchStock"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />
                   
                  </Box>
                </List>
              </Collapse>


              {/* <MenuItem onClick={() => setIsGraphCollapsed(!isGraphCollapsed)}>
                <ListItemIcon sx={{ float: 'right', marginTop: '10px', marginRight: '-40px' }}>
                  {isGraphCollapsed ? <ChevronRightIcon /> : <ExpandMoreIcon />}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="h6" style={{ fontSize: '18px', marginLeft: '15px', color: isGraphCollapsed && 'white' }}>
                      {!isCollapsed ? "Graphs" : ""}
                    </Typography>
                  }
                />
              </MenuItem>
              <Collapse in={isGraphCollapsed}>
                <List>
                  <Box paddingLeft={isCollapsed ? undefined : "4%"}>
                    <Item
                      title="Tonnage Graph"
                      to="/BarGraph"
                      icon={<EqualizerOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                  </Box>
                </List>
              </Collapse> */}

              <MenuItem></MenuItem>

            </React.Fragment>
          )}

          <MenuItem
            style={{
              color: 'red',
              cursor: "pointer",
              marginTop: "auto",
              marginLeft: '10px'
            }}
            onClick={() => handleLogout()}
            icon={<LogoutIcon />}
          >
            <Typography>Logout</Typography>
          </MenuItem>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
